import appConfig from "../config/app-config";

// We should probably use some kind of build-time log suppression
export function suppressLogs() {
  if (!!appConfig.suppressLogs) {
    console.log = () => {};
  }
}
